import { roles } from "shared/constants/Constants.js";

const userRoutes = {
  dashboard: [
    {
      path: "users_list",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "users-list" */
          "../../feature/user/dashboard/UserList.js"
        ),
      authorized: [
        // roles.ADMIN,
        roles.HUB_MANAGER,
        // roles.RECOVER_AGENT,
        roles.FLEET_GENERAL_MANAGER,
      ],
      sidebarGroup: "userList",
      sidebarLabel: "List",
    },
  ],
  standalone: [
    {
      path: "/user-profile-details-edit/:account_id",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "user-profile-details-screen-main" */
          "./user-profile-details-screen/UserProfileDetailsScreenMain.js"
        ),
      protected: true,
    },
  ],
};

export default userRoutes;
